// IQ Daily Pro products and plans (contracts/phase2.md §1), as the admin panel labels them.

export type ProPlan = "monthly" | "annual" | "lifetime" | "grant";

/** Display order: the two subscriptions, the one-time purchase, then support grants. */
export const PRO_PLANS = ["monthly", "annual", "lifetime", "grant"] as const satisfies readonly ProPlan[];

export const LIFETIME_PRODUCT = "iqdaily.pro.lifetime";

const PRODUCT_PLAN: Record<string, ProPlan> = {
  "iqdaily.pro.monthly": "monthly",
  "iqdaily.pro.annual": "annual",
  [LIFETIME_PRODUCT]: "lifetime",
};

/**
 * App Store Connect's US prices (2026-09-27), for staff reading the panel. The app never shows
 * these: it always shows StoreKit's localised price.
 */
export const PRODUCT_LABEL: Record<string, string> = {
  "iqdaily.pro.monthly": "Monthly · $5.99",
  "iqdaily.pro.annual": "Yearly · $29.99",
  [LIFETIME_PRODUCT]: "Lifetime · $99.99",
};

export const PLAN_LABEL: Record<ProPlan, string> = { monthly: "Monthly", annual: "Yearly", lifetime: "Lifetime", grant: "Support grant" };

/** The plan the API sent, else derived from the product and source (older backends send no `plan`). */
export function planOf(p: { plan?: string | null; productId?: string | null; source?: string | null }): ProPlan | null {
  if (p.plan && (PRO_PLANS as readonly string[]).includes(p.plan)) return p.plan as ProPlan;
  if (p.source === "grant") return "grant";
  return p.productId ? (PRODUCT_PLAN[p.productId] ?? null) : null;
}
